module.exports = __webpack_public_path__ + "img/comments-question-check.4f8ff433.svg";